// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_br-0";
export var headerCellHover = "_br-1";
export var readCellContainer = "_br-2";
export var readCellSlot = "_br-3";
export var rowHoverCheckbox = "_br-4";
export var rowUnreadIndicator = "_br-5";
export var searchHighlight = "_br-8";
export var summaryCellHoverWrapper = "_br-9";
export var supportTicketRow = "_br-6";
export var unreadIndicator = "_br-7";